/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase',
	'underscore',
	'./utils/WidgetUpgradeUtils'
], (UpgradeBase, _, WidgetUpgradeUtils) => {

	const propId = 'contrast.label.color';

	/**
		During the 11.2.0 Carbon effort we want to turn contast label color on by
		default. To do this and ensure users upgrade to the same looking vis we must
		set the property to false unless the user has set it to other value.
	*/
	class ContrastLabelUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 2001;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}

			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			/*
			* Cycle through all widgets and, if they are live widgets, upgrade the clipping.
			*/
			_.each(spec.widgets, model => {
				if (model && WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._upgradeContrastProperty(model);
				}
			});
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_upgradeContrastProperty(model) {
			// If the property wasn't set by the user, set it to false by default.
			if (!WidgetUpgradeUtils.findProperty(propId, model.properties)) {
				model.properties.push({
					id: propId,
					value: false
				});
			}
		}

	}

	return new ContrastLabelUpgrade();
});
